export default __webpack_public_path__ + "static/media/DanielVercelli.f7968068.png";